module.exports = __webpack_public_path__ + "img/rewards.8e460bda.png";